import React, {useState, useEffect, memo, useCallback, Fragment} from 'react';
import {    
            Button,
            Chip,
            Dialog,
            DialogActions,
            DialogTitle, 
            FormGroup,
            FormControlLabel,  
            Grid,
            IconButton,
            InputAdornment,
            LinearProgress,
            Paper,
            Switch,
            TextField
        } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { 
    AddCircleOutline as AddCircleOutlineIcon,
    AddLocation as AddLocationIcon,
    Delete as DeleteIcon,
    Done as DoneIcon,
    Http as HttpIcon,
    Nature as NatureIcon,
    VpnLock as VpnLockIcon,
} from '@material-ui/icons';
import { SnackbarProvider, useSnackbar } from 'notistack';
import  FacebookCircularProgress  from '../Elementos/FacebookCircularProgress';
import { Autocomplete } from '@material-ui/lab';
import { v4 as uuidv4 } from 'uuid'; 
import { useAuth } from "../Auth";
import { ClusterOutlined as ClusterOutlinedIcon  } from '@ant-design/icons';
import { 
    Switch as SwitchAntd, 
    Tooltip as TooltipAntd, 
} from 'antd';

const Register = ({data, handleProcess, Marcas, ModelosList, Empresas})=>{
    const { enqueueSnackbar } = useSnackbar();
    const [ isProcessing, setProcessing ] = useState(false);
    const [ openDialog, setOpenDialog ] = useState(false);
    const [ Datos, setDatos ] = useState({ 
        AddClientMikrotik:false,
        IP:'192.168',
        isFibraOptica:false, 
        Marca:'', 
        Modelo:'', 
        Nombre:'', 
        PagosConexion:false,
        Password:'',
        Planes:[],
        planLocal:false,
        ppoeList:false,
        queueTree:false,
        simpleQueue:false,
        sysintercom:false,
        Tipo:'', 
        Usuario:'admin', 
        isIptv:false,        
    });
    const [ validacion1, setValidacion1 ] = useState(false);
    const [ isDisableModelo, setDisableModelo ] = useState(true);
    const [ arrSubnet, setArrSubnet ] = useState([{Red:'',Mascara:0, id:Math.floor(Math.random() * 10000000)}]);
    const [ arrSubnetIptv, setArrSubnetIptv ] = useState([{Red:'',Mascara:0, id:Math.floor(Math.random() * 10000000)}]);
    const { authTokens } = useAuth(); 


    useEffect(()=>{
        if(validacion1){
            setValidacion1(false);
            enqueueSnackbar('Equipo Confirmado', {variant:'info'});
            setTimeout(()=>{
                handleSave();
            },1000);
        }
    },[validacion1]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleDatos = ({target})=>{ 
        if(target.name === 'Canton' || target.name === 'Provincia' || target.name === 'Parroquia' || target.name === 'Ciudad'){
            setDatos({...Datos, [target.name]:target.value.toUpperCase()}) 
        }else{
            setDatos({...Datos, [target.name]:target.value}) 
        }
    }

    const handleSwitch = (e)=>{
        switch(e.target.name){
            case 'simpleQueue':
                setDatos({...Datos, simpleQueue:e.target.checked, queueTree:false, ppoeList:false, sysintercom:false});
                break;
            case 'queueTree':
                setDatos({...Datos, queueTree:e.target.checked, simpleQueue:false, ppoeList:false, sysintercom:false});
                break;
            case 'ppoeList':
                setDatos({...Datos, ppoeList:e.target.checked, simpleQueue:false, queueTree:false, sysintercom:false});
                break;
            case 'sysintercom':
                setDatos({...Datos, sysintercom:e.target.checked, simpleQueue:false, queueTree:false, ppoeList:false});
                break;
            default:
                break;
        };
    };

    const handleSwitchPago = (checked)=>{ setDatos({...Datos, PagosConexion:checked}) };

    const handleSwitchPlanes = (checked)=>{ setDatos({...Datos, planLocal:checked}) };

    const handleSwitchAdd = (checked)=>{ setDatos({...Datos, AddClientMikrotik:checked}) };

    const handleSwitchFibra = (checked)=>{ setDatos({...Datos, isFibraOptica:checked}) };

    const handleValidacion1 = ()=>{
        setOpenDialog(false);
        if(Datos.Marca === ''){ enqueueSnackbar('Campo Marca Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.Modelo === ''){ enqueueSnackbar('Campo Modelo Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.Zona === ''){ enqueueSnackbar('Campo Zona Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.IP === ''){enqueueSnackbar('Campo IP Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.Usuario === ''){ enqueueSnackbar('Campo Usuario Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.Password === ''){ enqueueSnackbar('Campo Password Vacio' , {variant:'error'}); setProcessing(false);
        }else{ if(Datos.Puerto === ''){ enqueueSnackbar('Campo Puerto Vacio' , {variant:'error'}); setProcessing(false);
        }else{   
            fetch('api/mikrotik/ccr/validar',{
                method:'POST',
                body: JSON.stringify(Datos),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then(result =>{
                if(result.message){
                    setValidacion1(true);
                }else{
                    enqueueSnackbar(result.status, {variant:'error'});
                    console.log(result);
                    setProcessing(false);                               
                }
            });
        }}}}}}}
        
    };

    const handleSave = ()=>{
        const objeto = {...Datos};
        objeto.UsuarioCreate = authTokens.Usuario;
        objeto.Planes = [];
        objeto.Subnet = arrSubnet;
        objeto.SubnetIptv = arrSubnetIptv;
        objeto.uuid = uuidv4();
        fetch('api/zonas',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar('Zona Guardada', {variant:'success'});
                setProcessing(false);
                handleProcess(result.message);
                setDatos({ 
                    AddClientMikrotik:false, 
                    IP:'192.168',
                    isFibraOptica:false ,
                    Marca:'', 
                    Modelo:'', 
                    Nombre:'',
                    Tipo:'',   
                    PagosConexion:false,
                    Password:'', 
                    Planes:[],
                    planLocal:false,
                    ppoeList:false, 
                    queueTree:false,
                    simpleQueue:false,
                    sysintercom:false,
                    Usuario:'admin', 
                });
                setArrSubnet([{Red:'', Mascara:0, id:'Subnet_1'}]);
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setProcessing(false);
            }
        });   
    };
    
    const handleAlert = ()=>{
        if(!isProcessing){
            setOpenDialog(true);
            setProcessing(true);
        }
    };

    const handleAlertClose = ()=>{
        setOpenDialog(false);
        setProcessing(false);
    };

    const handleSelectMarca = (value)=>{
        setDatos({...Datos, Marca:value });
        setDisableModelo(false);
    };

    const handleClearMarca = ()=>{
        setDatos({...Datos, Marca:'', Modelo:''});
        setDisableModelo(true);
    };

    const handleSubnet = useCallback((idSubnet, valPlan)=>{
        const arrS = [...arrSubnet];
        const arr = arrS.map(value=>{
            const objeto = {...value}
            if(value.id === idSubnet){
                return valPlan;
            }else{
                return objeto;
            }
        });
        setArrSubnet(arr);
    },[arrSubnet]);

    const handleCrearSubnet = useCallback(()=>{
        setArrSubnet([...arrSubnet, {Red:'',Mascara:0, id:Math.floor(Math.random() * 10000000)}]);
    },[arrSubnet]);
    
    const handleBorrarSubnet = useCallback((id)=>{
        const arrS = [...arrSubnet];
        const filSubnet = arrS.filter(value=> value.id !== id);
        setArrSubnet(filSubnet);
    },[arrSubnet]);

    const SubnetEl = arrSubnet.map((value, index)=>(
        <ElementSubnet index={index} key={value.id} data={value} id={value.id}  
          total={arrSubnet.length} 
          handleSubnet={handleSubnet}
          handleCrearSubnet={handleCrearSubnet}
          handleBorrarSubnet={handleBorrarSubnet}
          arrSubnet={arrSubnet}
        />
    ));

    const handleSubnetIptv = useCallback((idSubnet, valPlan)=>{
        const arrS = [...arrSubnetIptv];
        const arr = arrS.map(value=>{
            const objeto = {...value}
            if(value.id === idSubnet){
                return valPlan;
            }else{
                return objeto;
            }
        });
        setArrSubnetIptv(arr);
    },[ arrSubnetIptv ]);

    const handleCrearSubnetIptv = useCallback(()=>{
        setArrSubnetIptv([...arrSubnetIptv, {Red:'',Mascara:0, id:Math.floor(Math.random() * 10000000)}]);
    },[ arrSubnetIptv ]);
    
    const handleBorrarSubnetIptv = useCallback((id)=>{
        const arrS = [...arrSubnetIptv];
        const filSubnet = arrS.filter(value=> value.id !== id);
        setArrSubnetIptv(filSubnet);
    },[ arrSubnetIptv ]);

    const SubnetElIptv = arrSubnetIptv.map((value, index)=>(
        <ElementSubnetIptv index={index} key={value.id} data={value} id={value.id}  
          total={arrSubnetIptv.length} 
          handleSubnetIptv={handleSubnetIptv}
          handleCrearSubnetIptv={handleCrearSubnetIptv}
          handleBorrarSubnetIptv={handleBorrarSubnetIptv}
          arrSubnetIptv={arrSubnetIptv}
        />
    ));

    const handleSelectModelo = (value)=>{ setDatos({...Datos, Modelo:value.toString().trim()});};

    const handleClearModelo = ()=>{setDatos({...Datos, Modelo:''});};

    return(
            <Grid container direction="row" justifyContent="center" alignItems="center" spacing={3} style={{ padding:10, }}>     
                <Dialog
                    open={openDialog}
                    onClose={handleAlertClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Desea Guardar este Equipo"} </DialogTitle>
                    <DialogActions style={{display:'flex', justifyContent:'center'}}>
                    <Button onClick={handleValidacion1} color="primary" variant='contained' style={{color:'#fff'}}>
                        Si
                    </Button>
                    <Button onClick={handleAlertClose} color="default" variant='contained' style={{color:'#fff'}}>
                        No
                    </Button>
                    </DialogActions>
                </Dialog>  
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    {isProcessing ? <LinearProgress color='secondary' /> : <div style={{height:4}}></div>}
                </Grid>     
                <Grid item lg={2} md={4} sm={6} xs={12}>
                    <Autocomplete
                        id="Marca"
                        options={Marcas.map(value=>value.Marca)}
                        value={Datos.Marca || ''}                              
                        renderInput={(params) => <TextField {...params} label="Marca" variant="outlined" size='small' fullWidth />}
                        onChange={(e,value, reason)=>{
                            if(reason ===  'clear'){
                                handleClearMarca()
                            }else{
                                handleSelectMarca(value);
                            }
                        }}  
                    />
                </Grid>                 
                <Grid item lg={2} md={4} sm={6} xs={12}>
                    <Autocomplete
                        id="Modelo"
                        options={ModelosList.map(value=>value.Modelo)}
                        disabled={isDisableModelo}
                        value={Datos.Modelo || ''}                              
                        renderInput={(params) => <TextField {...params} label="Modelo" variant="outlined" size='small' fullWidth />}
                        onChange={(e,value, reason)=>{
                            if(reason ===  'clear'){
                                handleClearModelo()
                            }else{
                                handleSelectModelo(value);
                            }
                        }}  
                    />
                </Grid>   
                <Grid item lg={2} md={4} sm={6} xs={12}>
                    <TextField
                        value={Datos.Zona || ''}
                        name='Zona'
                        onChange={handleDatos}
                        label='Zona'
                        fullWidth
                        size='small'
                        variant='outlined'  
                        InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <AddLocationIcon color='primary'/>
                              </InputAdornment>
                            ),
                        }}                             
                    />
                </Grid>
                <Grid item lg={2} md={4} sm={6} xs={12}>
                    <TextField
                        value={Datos.IP || ''}
                        name='IP'
                        onChange={handleDatos}
                        label='IP'
                        fullWidth
                        size='small'
                        variant='outlined'  
                        InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <HttpIcon color='primary'/>
                              </InputAdornment>
                            ),
                        }}                               
                    />
                </Grid> 
                <Grid item lg={2} md={4} sm={6} xs={12}>
                    <TextField
                        value={Datos.IPSECONDARY || ''}
                        name='IPSECONDARY'
                        onChange={handleDatos}
                        label='IP SECUNDARIA'
                        fullWidth
                        size='small'
                        variant='outlined'  
                        InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <HttpIcon color='primary'/>
                              </InputAdornment>
                            ),
                        }}                               
                    />
                </Grid> 
                <Grid item lg={1} md={2} sm={3} xs={6}>
                    <TextField
                        value={Datos.Puerto || ''}
                        name='Puerto'
                        onChange={handleDatos}
                        label='Puerto API'
                        fullWidth
                        size='small'
                        variant='outlined' 
                        type='Number'                             
                    />
                </Grid>
                <Grid item lg={1} md={2} sm={3} xs={6} style={{display:'grid', placeContent:'center'}}>
                    <TooltipAntd title="IP PRIMARIA O SECUNDARIA" color='purple' >
                        <SwitchAntd 
                            checked={Datos.isSecondary}
                            checkedChildren="SECUNDARIA" 
                            onChange={(checked)=>{ setDatos({...Datos, isSecundary:checked })}}
                            unCheckedChildren="PRIMARIA" 
                            
                        />
                    </TooltipAntd>              
                </Grid>
                <Grid item lg={2} md={3} sm={6} xs={12}>
                    <TextField
                        value={Datos.Nodo || ''}
                        name='Nodo'
                        onChange={handleDatos}
                        label='Nodo'
                        fullWidth
                        size='small'
                        variant='outlined'                              
                    />
                </Grid>
                <Grid item lg={2} md={3} sm={6} xs={12}>
                    <TextField
                        value={Datos.Usuario || ''}
                        name='Usuario'
                        onChange={handleDatos}
                        label='Usuario'
                        fullWidth
                        size='small'
                        variant='outlined'                              
                    />
                </Grid>        
                <Grid item lg={2} md={3} sm={6} xs={12}>
                    <TextField
                        value={Datos.Password || ''}
                        name='Password'
                        onChange={handleDatos}
                        label='Password'
                        fullWidth
                        size='small'
                        variant='outlined'                              
                    />
                </Grid>
                <Grid item lg={2} md={3} sm={6} xs={12}>
                    <Autocomplete
                        id="Empresa"
                        options={Empresas}
                        value={Datos.Empresa || ''}                              
                        renderInput={(params) => <TextField {...params} label="Empresa" variant="outlined" size='small' fullWidth />}
                        onChange={(e,value, reason)=>{
                            if(reason ===  'clear'){
                                setDatos({...Datos, Empresa:'' });
                            }else{
                                setDatos({...Datos, Empresa:value });
                            }
                        }}  
                    />
                </Grid>  
                <Grid item lg={2} md={3} sm={6} xs={12}>
                    <TextField
                        value={Datos.Provincia || ''}
                        name='Provincia'
                        onChange={handleDatos}
                        label='Provincia'
                        fullWidth
                        size='small'
                        variant='outlined'                              
                    />
                </Grid>
                <Grid item lg={2} md={3} sm={4} xs={12}>
                    <TextField
                        value={Datos.Canton || ''}
                        name='Canton'
                        onChange={handleDatos}
                        label='Canton'
                        fullWidth
                        size='small'
                        variant='outlined'                              
                    />
                </Grid>
                <Grid item lg={2} md={3} sm={4} xs={12}>
                    <TextField
                        value={Datos.Parroquia || ''}
                        name='Parroquia'
                        onChange={handleDatos}
                        label='Parroquia'
                        fullWidth
                        size='small'
                        variant='outlined'                              
                    />
                </Grid>
                <Grid item lg={2} md={3} sm={4} xs={12}>
                    <TextField
                        value={Datos.Ciudad || ''}
                        name='Ciudad'
                        onChange={handleDatos}
                        label='Ciudad'
                        fullWidth
                        size='small'
                        variant='outlined'                              
                    />
                </Grid>
                <Grid item lg={1} md={3} sm={3} xs={3} style={{display:'grid', placeContent:'center'}}>
                    <TooltipAntd title="TIPO DE SERVICIO" color='purple' >
                        <SwitchAntd 
                            checked={Datos.isFibraOptica}
                            checkedChildren="FIBRA" 
                            onChange={handleSwitchFibra}
                            unCheckedChildren="RADIO" 
                            
                        />
                    </TooltipAntd>              
                </Grid>
                <Grid item lg={3} md={6} sm={5} xs={9}>
                    <Grid container alignItems="center" spacing={1} style={{width:'100%'}} justifyContent='center'>
                        <Grid item>
                            <TooltipAntd title="SINCRONIZAR CLIENTE CON EL MIKROTIK" color='purple' >
                                <SwitchAntd 
                                    checked={Datos.AddClientMikrotik}
                                    checkedChildren="SI" 
                                    onChange={handleSwitchAdd}
                                    unCheckedChildren="NO" 
                                />
                            </TooltipAntd> 
                        </Grid>
                        <Grid item>
                            <Alert severity='info'>                          
                                SYNC CLIENT MK?
                            </Alert>
                        </Grid>
                    </Grid>            
                </Grid>
                <Grid item lg={2} md={3} sm={4} xs={12}>
                    <Grid container  alignItems="center" spacing={1} style={{width:'100%'}} justifyContent='center'>
                        <Grid item>
                            <TooltipAntd title="SINCRONIZAR PAGOS CON EL MIKROTIK" color='purple' >
                                <SwitchAntd 
                                    checked={Datos.PagosConexion}
                                    checkedChildren="SI" 
                                    onChange={handleSwitchPago}
                                    unCheckedChildren="NO" 
                                />
                            </TooltipAntd> 
                        </Grid>
                        <Grid item>
                            <Alert severity='info'>                          
                                PAGOS MK?
                            </Alert>
                        </Grid>
                    </Grid>            
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={4} style={{display:'grid', placeContent:'center'}}>
                    <TooltipAntd title="ZONA CON IPTV" color='purple' >
                        <SwitchAntd 
                            checked={Datos.isIptv}
                            checkedChildren="SI IPTV" 
                            onChange={(checked)=>{setDatos({...Datos, isIptv:checked})}}
                            unCheckedChildren="NO IPTV" 
                        />
                    </TooltipAntd>           
                </Grid>
                <Grid item lg={2} md={4} sm={5} xs={8}>
                    <Grid container  alignItems="center" spacing={1} style={{width:'100%'}} justifyContent='center'>
                        <Grid item>
                            <TooltipAntd title="TIPO DE PLANES" color='purple' >
                                <SwitchAntd 
                                    checked={Datos.planLocal}
                                    checkedChildren="ZONA" 
                                    onChange={handleSwitchPlanes}
                                    unCheckedChildren="GENERAL" 
                                />
                            </TooltipAntd>    
                        </Grid>
                        <Grid>
                            <Alert severity='info'>                          
                                    PLANES?
                            </Alert>
                        </Grid>
                    </Grid>            
                </Grid>
                <Grid item lg={2} md={2} sm={4} xs={12}>
                    <Button onClick={handleAlert} variant='contained'  fullWidth color='primary' size='large' endIcon={<DoneIcon />}>
                        {isProcessing ? <FacebookCircularProgress size={12} style={{marginTop:5}}/> : 'Procesar'}
                    </Button>
                </Grid>

                <Grid item lg={9} xs={12}> 
                    <Grid container spacing={2} justifyContent='center'>
                        <Grid item>
                            <FormGroup row style={{display:'flex', justifyContent:'center'}}>
                                <FormControlLabel
                                    style={{margin:10}}
                                    control={
                                    <Switch
                                        checked={Datos.sysintercom}
                                        onChange={handleSwitch}
                                        name="sysintercom"
                                        color="primary"
                                    />
                                    }
                                    label="Ques/Address_Lists"
                                />
                                <FormControlLabel
                                    style={{margin:10}}
                                    control={
                                    <Switch
                                        checked={Datos.simpleQueue}
                                        onChange={handleSwitch}
                                        name="simpleQueue"
                                        color="primary"
                                    />
                                    }
                                    label="Ques_Simple"
                                />
                                <FormControlLabel
                                    style={{margin:10}}
                                    control={
                                    <Switch
                                        checked={Datos.queueTree}
                                        onChange={handleSwitch}
                                        name="queueTree"
                                        color="primary"
                                    />
                                    }
                                    label="Ques_tree"
                                />
                                <FormControlLabel
                                    style={{margin:10}}
                                    control={
                                    <Switch
                                        checked={Datos.ppoeList}
                                        onChange={handleSwitch}
                                        name="ppoeList"
                                        color="primary"
                                    />
                                    }
                                    label="Server_PPPoE"
                                />
                            </FormGroup>
                        </Grid>
                        <Grid item>
                            <Alert severity='info'>                          
                                    Tipo de Manejo de Clientes
                            </Alert>
                        </Grid>
                    </Grid>                             
                </Grid>  
                <Grid item xs={12} lg={6}>
                    <Grid container spacing={1} justifyContent='center' style={{width:'100%'}}>
                        <Grid item>
                            <Chip label=' S U B N E T S ' color='secondary' style={{color:'#fff', fontWeight:'bolder'}} icon={<VpnLockIcon />}/>
                        </Grid>
                        { SubnetEl }
                    </Grid>
                </Grid>  
                {
                    Datos.isIptv && 
                    <Grid item xs={12} lg={6}>
                        <Grid container spacing={1} justifyContent='center' style={{width:'100%'}}>
                            <Grid item>
                                <Chip label=' S U B N E T S - I P T V ' color='secondary' style={{color:'#fff', fontWeight:'bolder'}} icon={<VpnLockIcon />}/>
                            </Grid>
                            { SubnetElIptv }
                        </Grid>
                    </Grid>
                }
                {   Datos.isFibraOptica &&
                    <Grid item xs={12} lg={6}>
                        <Grid container spacing={1} justifyContent='center' style={{width:'100%'}}>                             
                            <Grid item>
                                <Chip label=' OLT ' color='secondary' style={{color:'#fff', fontWeight:'bolder'}} icon={<ClusterOutlinedIcon />}/>
                            </Grid>
                            <Grid item xs={12}>
                                <Paper style={{width:'100%', padding:10, minHeight:68}} square elevation={2}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={8}>
                                            <TextField
                                                value={Datos.OLTIP || ''}
                                                name='OLTIP'
                                                onChange={handleDatos}
                                                label='IP'
                                                fullWidth
                                                size='small'
                                                variant='outlined'                                
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextField
                                                value={Datos.OLTPORT || ''}
                                                name='OLTPORT'
                                                type='Number'
                                                onChange={handleDatos}
                                                label='PORT TELNET'
                                                fullWidth
                                                size='small'
                                                variant='outlined'                              
                                            />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                            <TextField
                                                value={Datos.OLTUSER || ''}
                                                name='OLTUSER'
                                                onChange={handleDatos}
                                                label='USUARIO'
                                                fullWidth
                                                size='small'
                                                variant='outlined'                                
                                            />
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                            <TextField
                                                value={Datos.OLTPASS || ''}
                                                name='OLTPASS'
                                                onChange={handleDatos}
                                                label='PASSWORD'
                                                fullWidth
                                                size='small'
                                                variant='outlined'                                
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>                            
                        </Grid>
                    </Grid> 
                }
            </Grid>
    );
};

const ElementSubnet = memo((props)=>{
    const { index, total, id, handleBorrarSubnet, handleCrearSubnet, arrSubnet, handleSubnet } = props;
    const [ Datos, setDatos ] = useState({Red:'', Mascara:0, id});
    let cantItem = index + 1;
  
    const handleSubBorrarSubnet = ()=>{ handleBorrarSubnet(id); };

    const handleDatos = (e)=>{ setDatos({...Datos, [e.target.id]:e.target.value}); };

    const handleSubSubnetRed = ({target})=>{
        const arrS = [...arrSubnet];
        const arrF = arrS.filter(el=>el.id !== Datos.id ); 
        const arrFil = arrF.filter(el=>el.Red.toString() === target.value );
        if(arrFil.length === 0 ){
            const objeto = {...Datos};
            objeto.Red = target.value;
            handleSubnet(id, objeto);
        }else{
            alert('YA EXISTE UN SEGMENTO DE RED IGUAL')
        }
    };

    const handleSubSubnetMask = ({target})=>{
        const objeto = {...Datos};
        objeto.Mascara = target.value;
        handleSubnet(id, objeto);
    };

    if(arrSubnet.length === 1){
        return(
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} >  
                <Paper elevation={2} style={{padding:10}} square >
                    <Grid container justifyContent='center' spacing={1}>
                        <Grid item xl={8} lg={8} md={8} sm={8} xs={8}>
                            <TextField
                                value={Datos.Red || ''}
                                id='Red'
                                onChange={handleDatos}
                                label='Red'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                onBlur={handleSubSubnetRed}
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <NatureIcon color='primary'/>
                                    </InputAdornment>
                                    ),
                                }}                             
                            />
                        </Grid>  
                        <Grid item xl={3} lg={3} md={3} sm={3} xs={3}>
                            <TextField
                                value={Datos.Mascara || ''}
                                id='Mascara'
                                type='Number'
                                onChange={handleDatos}
                                label='Mascara'
                                fullWidth
                                size='small'
                                variant='outlined'   
                                onBlur={handleSubSubnetMask}                           
                            />
                        </Grid>                  
                        <Grid item xl={1} lg={1} md={1} sm={1} xs={1}>
                            <IconButton onClick={handleCrearSubnet} style={{position:'relative', top:-3, left:-12}}>
                                <AddCircleOutlineIcon color='primary'/>
                            </IconButton>
                        </Grid>
                    </Grid>         
                </Paper>
            </Grid>             
        );
    }else{
        return(         
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <Paper elevation={2} style={{padding:10}} square>
                    <Grid container justifyContent='center' spacing={1} >
                        <Grid item xl={7} lg={7} md={7} sm={7} xs={7}>
                            <TextField
                                value={Datos.Red || ''}
                                id='Red'
                                onChange={handleDatos}
                                label='Red'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                onBlur={handleSubSubnetRed}
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <NatureIcon color='primary'/>
                                    </InputAdornment>
                                    ),
                                }}                             
                            />
                        </Grid>  
                        <Grid item xl={3} lg={3} md={3} sm={3} xs={3}>
                            <TextField
                                value={Datos.Mascara || ''}
                                id='Mascara'
                                type='Number'
                                onChange={handleDatos}
                                label='Mascara'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                onBlur={handleSubSubnetMask}                            
                            />
                        </Grid>
                        <Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
                            { cantItem === total && 
                            <Fragment >
                                <IconButton onClick={handleCrearSubnet} size='small' style={{position:'relative', top:5}}      >
                                    <AddCircleOutlineIcon color='primary'/>
                                </IconButton>
                                <IconButton onClick={handleSubBorrarSubnet} size='small' style={{position:'relative', top:5}}      >
                                    <DeleteIcon style={{color:'red'}}/>
                                </IconButton>
                            </Fragment>
                            }
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>   
        );
    }
    
});

const ElementSubnetIptv = memo((props)=>{
    const { index, total, id, handleBorrarSubnetIptv, handleCrearSubnetIptv, arrSubnetIptv, handleSubnetIptv } = props;
    const [ Datos, setDatos ] = useState({Red:'', Mascara:0, id});
    let cantItem = index + 1;
  
    const handleSubBorrarSubnetIptv = ()=>{ handleBorrarSubnetIptv(id); };

    const handleDatos = (e)=>{ setDatos({...Datos, [e.target.id]:e.target.value}); };

    const handleSubSubnetRedIptv = ({target})=>{
        const arrS = [...arrSubnetIptv];
        const arrF = arrS.filter(el=>el.id !== Datos.id ); 
        const arrFil = arrF.filter(el=>el.Red.toString() === target.value );
        if(arrFil.length === 0 ){
            const objeto = {...Datos};
            objeto.Red = target.value;
            handleSubnetIptv(id, objeto);
        }else{
            alert('YA EXISTE UN SEGMENTO DE RED IGUAL')
        }
    };

    const handleSubSubnetMaskIptv = ({target})=>{
        const objeto = {...Datos};
        objeto.Mascara = target.value;
        handleSubnetIptv(id, objeto);
    };

    if(arrSubnetIptv.length === 1){
        return(
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} >  
                <Paper elevation={2} style={{padding:10}} square >
                    <Grid container justifyContent='center' spacing={1}>
                        <Grid item xl={8} lg={8} md={8} sm={8} xs={8}>
                            <TextField
                                value={Datos.Red || ''}
                                id='Red'
                                onChange={handleDatos}
                                label='Red'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                onBlur={handleSubSubnetRedIptv}
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <NatureIcon color='primary'/>
                                    </InputAdornment>
                                    ),
                                }}                             
                            />
                        </Grid>  
                        <Grid item xl={3} lg={3} md={3} sm={3} xs={3}>
                            <TextField
                                value={Datos.Mascara || ''}
                                id='Mascara'
                                type='Number'
                                onChange={handleDatos}
                                label='Mascara'
                                fullWidth
                                size='small'
                                variant='outlined'   
                                onBlur={handleSubSubnetMaskIptv}                           
                            />
                        </Grid>                  
                        <Grid item xl={1} lg={1} md={1} sm={1} xs={1}>
                            <IconButton onClick={handleCrearSubnetIptv} style={{position:'relative', top:-3, left:-12}}>
                                <AddCircleOutlineIcon color='primary'/>
                            </IconButton>
                        </Grid>
                    </Grid>         
                </Paper>
            </Grid>             
        );
    }else{
        return(         
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <Paper elevation={2} style={{padding:10}} square>
                    <Grid container justifyContent='center' spacing={1} >
                        <Grid item xl={7} lg={7} md={7} sm={7} xs={7}>
                            <TextField
                                value={Datos.Red || ''}
                                id='Red'
                                onChange={handleDatos}
                                label='Red'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                onBlur={handleSubSubnetRedIptv}
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <NatureIcon color='primary'/>
                                    </InputAdornment>
                                    ),
                                }}                             
                            />
                        </Grid>  
                        <Grid item xl={3} lg={3} md={3} sm={3} xs={3}>
                            <TextField
                                value={Datos.Mascara || ''}
                                id='Mascara'
                                type='Number'
                                onChange={handleDatos}
                                label='Mascara'
                                fullWidth
                                size='small'
                                variant='outlined'  
                                onBlur={handleSubSubnetMaskIptv}                            
                            />
                        </Grid>
                        <Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
                            { cantItem === total && 
                            <Fragment >
                                <IconButton onClick={handleCrearSubnetIptv} size='small' style={{position:'relative', top:5}}      >
                                    <AddCircleOutlineIcon color='primary'/>
                                </IconButton>
                                <IconButton onClick={handleSubBorrarSubnetIptv} size='small' style={{position:'relative', top:5}}      >
                                    <DeleteIcon style={{color:'red'}}/>
                                </IconButton>
                            </Fragment>
                            }
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>   
        );
    }
    
});

const Registrar = ({data, Empresas, handleProcess, handleUpdate, Marcas, ModelosList})=>{
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}>
            <Register 
                data={data} 
                Empresas={Empresas}
                handleProcess={handleProcess} 
                handleUpdate={handleUpdate} 
                Marcas={Marcas} 
                ModelosList={ModelosList}
            />
        </SnackbarProvider>
    );
};

export default Registrar;
